<!-- <p-treeSelect styleClass="w-100 product-tree"
              [filter]="true"
              class="w-100 product-tree"
              containerStyleClass="w-100 product-tree"
              [options]="_allProducts"
              (onNodeSelect)="onProductSelected($event.node.data)"
              showClear="false"
              (onClear)="onProductSelected(undefined)"
              [(ngModel)]="selectedProduct"
              placehoder="Select a Product"
              (onShow)="onShowTree($event)"
              appendTo="body"></p-treeSelect> -->

<span class="p-input-icon-right w-100">
   <!-- <i class="pi pi-times"
       (click)="selectedProduct=undefined;onProductSelected($event);"></i> -->
   <input
      style="font-weight: 600; color: #1a1b1b !important; padding-left: 10px"
      class="w-100"
      pInputText
      readonly
      [value]="selectedProduct?.label"
      placeholder="Select a Vetcor Product..."
      (focus)="showPanel($event)" />
</span>

<p-overlayPanel
   #op
   styleClass="product-tree-select">
   <ng-template pTemplate="content">
      <vc-spinner *ngIf="loading"></vc-spinner>
      <div
         *ngIf="useCustomFilter"
         class="input-group px-3 pt-3">
         <input
            type="text"
            class="form-control w-100"
            placeholder="Filter..."
            (input)="filterTextChanged$.next($event.target.value)" />
      </div>
      <p-tree
         *ngIf="!loading"
         id="p-tree-select"
         #tree
         [filter]="!useCustomFilter"
         class="w-100 has-text-filter"
         [value]="nodesToShow$ | async"
         selectionMode="single"
         [(selection)]="selectedProduct"
         virtualScroll="true"
         scrollHeight="400px"
         virtualScrollItemSize="32"
         (onNodeSelect)="onProductSelected($event)"></p-tree>
   </ng-template>
</p-overlayPanel>
